import React from 'react';
import { backgroundTexture } from '../../data/offer';
type IndustrialBackdropProps = {
  opacity?: 'faint' | 'soft';
};
export function IndustrialBackdrop({
  opacity = 'faint'
}: IndustrialBackdropProps) {
  return <div className="pointer-events-none absolute inset-0 -z-10" aria-hidden="true" data-id="element-216" data-mp="4f0yp1i3bdyw">
      <img src={backgroundTexture} alt="" className={`h-full w-full object-cover ${opacity === 'soft' ? 'opacity-50' : 'opacity-25'}`} data-id="element-217" data-mp="3vltwrwhl6wz7" />
      <div className="absolute inset-0 bg-slate-950/60" data-id="element-218" data-mp="37xaohgyjek74" />
    </div>;
}